module.exports = __webpack_public_path__ + "img/ResidentControl2.e2e09bab.png";